import "core-js/modules/web.dom.iterable";
import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
/* eslint-disable */
_typeof(window.componentCenter) == "object" || (window.componentCenter = {});
import { toQueryString, toast } from "@ykz/ykz-util/base";
import { previewImage as _previewImage } from "@ykz/ykz-util/platform";
import Databus, { Origins } from "@ykz/ykz-http/core";
import { getWeChatList } from "@ykz/ykz-http/common";
export default {
  name: "userEvaluation",
  data: function data() {
    return {
      defaultAvatar: window.comm.defaultUserAvatar,
      fromWeChatId: getUrlParams("fromWeChatId") || 1,
      weChatId: getUrlParams("weChatId") || window.weChatId || 1,
      scenicId: getUrlParams("scenicId") || "",
      storeId: getUrlParams("storeId") || "",
      goodId: getUrlParams("goodId") || "",
      isInApp: window.mobileEnv == "app" ? true : false,
      //是否在app打开
      comment: null,
      isGoodsDetails: false,
      // 是否是酒景页
      isStoreDetails: false,
      availableWechatId: false
    };
  },
  mounted: function mounted() {
    console.log("ycf组件初始化：userEvaluation");
    window.componentCenter.userEvaluation = this;
    this.isGoodsDetails = !!(location.href.indexOf("goodsDetails") > -1);
    this.isStoreDetails = !!(location.href.indexOf("storeDetails") > -1);
    this.ajaxGetCommentList();
    this.ajaxGetWeChatList();
  },
  methods: {
    goEvaluation: function goEvaluation() {
      var that = this,
        url = "/front/index/userEvaluation?" + toQueryString({
          scenicId: that.scenicId,
          storeId: that.storeId,
          weChatId: that.weChatId,
          fromWeChatId: that.fromWeChatId,
          goodId: that.goodId
        });
      if (this.isGoodsDetails || this.isStoreDetails) {
        YCF_Plugin.reportUserAnchors({
          event_id: "520003",
          event_content: {
            item_id: this.scenicId || this.storeId,
            scenicFrom: getUrlParams("scenicFrom") || "",
            element_content: "clickEvaluation"
          },
          page_name: this.isGoodsDetails ? "酒景详情页" : "门店详情页"
        }).always(function () {
          goEvaluationHelper(YCF_Plugin.getNavigateUrl(url, {}));
        });
      } else {
        goEvaluationHelper(url);
      }
      function goEvaluationHelper(url) {
        if (!that.comment || !that.comment.count) {
          return false;
        }
        location.href = url;
      }
    },
    // 获取用户评论
    ajaxGetCommentList: function ajaxGetCommentList() {
      var that = this;
      Databus({
        url: "/apiv2/hotel/getCommentList",
        data: {
          scenicId: that.scenicId || that.storeId || "",
          goodId: that.goodId || "",
          pageIndex: 1,
          pageSize: 1,
          resourceType: that.storeId ? 1 : 0
        },
        type: "GET",
        success: function success(data) {
          if (data.code === 1000 && data.bcode === 100 && data.content) {
            if (data.content.list && data.content.list.length > 0) {
              that.comment = that.updateImgUrls(data.content.list[0]);
              that.comment.count = data.content.count;
              that.$emit("ready", that.comment);
            } else {
              that.$emit("ready", {});
            }
          } else {
            that.$emit("ready", {});
            console.log("获取评论信息失败:" + data.message);
          }
        },
        error: function error() {
          that.$emit("ready", {});
          toast("网络有误，请刷新重试");
        }
      });
    },
    updateImgUrls: function updateImgUrls(row) {
      row.allImgs = [];
      var videoList = row.commentVideos && row.commentVideos.length ? row.commentVideos.map(function (item) {
        return {
          type: "video",
          url: "".concat(item.coverImageUrl, "?imageView2/1/w/200/h/200/interlace/1/q/100")
        };
      }) : [];
      var imageList = row.imageUrls && row.imageUrls.length ? row.imageUrls.map(function (item) {
        return {
          type: "image",
          url: "".concat(item, "?imageView2/1/w/200/h/200/interlace/1/q/100")
        };
      }) : [];
      row.allImgs = videoList.concat(imageList); // 合并视频和图片列表

      return row;
    },
    // 获取当前公众号是否可以展示评价模块
    ajaxGetWeChatList: function ajaxGetWeChatList() {
      var _this = this;
      if (getUrlParams("weChatId") == 1 && (this.isGoodsDetails || this.isStoreDetails)) {
        this.availableWechatId = true;
        return;
      }
      getWeChatList().then(function (data) {
        if (data.code === 1000 && data.bcode === 100) {
          var wechatList = data.content || [];
          wechatList.forEach(function (item) {
            if (item == _this.weChatId) {
              _this.availableWechatId = true;
            }
          });
        } else {
          console.log("获取公众号信息失败:" + data.message);
        }
      }).fail(function () {
        toast("网络有误，请刷新重试");
      });
    },
    previewImage: function previewImage(index, url) {
      var that = this,
        photosUrl = that.comment.allImgs || [];
      if (that.isInApp) {
        ykzApp.showPhotoGallery({
          photoUrls: photosUrl,
          curIndex: index
        });
      } else {
        _previewImage({
          current: url,
          // 当前显示图片的http链接
          urls: photosUrl // 需要预览的图片http链接列表
        });
      }
    }
  },

  filters: {
    formatScore: function formatScore(score) {
      if (score < 10000) {
        return score;
      }
      if (score % 10000 == 0) {
        return score / 10000 + ".0万";
      }
      return (score / 10000).toFixed(1) + "万+";
    },
    formatTime: function formatTime(time) {
      var date = new Date(time * 1000),
        year = addZero(date.getFullYear()),
        month = addZero(date.getMonth() + 1),
        day = addZero(date.getDate()),
        hour = addZero(date.getHours()),
        miniute = addZero(date.getMinutes()),
        seconds = addZero(date.getSeconds());
      return month + "-" + day;
      function addZero(num) {
        if (num < 10) {
          return "0" + num;
        }
        return num;
      }
    }
  }
};